module.exports = __webpack_public_path__ + "static/media/photo1@2x.80fb2764.jpg";